const STAGE_LABELS = Object.freeze({
  queued: "Waiting to start...",
  starting: "Preparing...",
  downloading: "Preparing...",
  analyzing: "Analyzing media...",
  transcoding: "Processing media...",
  uploading: "Finalizing...",
  complete: "Complete!",
});

const stageLabel = (stage) => STAGE_LABELS[stage] ?? "Processing...";

export { STAGE_LABELS, stageLabel };
export default stageLabel;
